import { InfoOutlined } from '@/shared/ui/icons';

const AppVersion = () => {
  const appVersion = import.meta.env.VITE_REACT_APP_VERSION;

  return (
    <div className='flex items-center gap-2 text-sm text-gx-text-disabled'>
      <InfoOutlined
        aria-hidden
        sx={{ fontSize: 14 }}
      />
      <p>GX Go app version {appVersion}</p>
    </div>
  );
};

export default AppVersion;
